import Modal from '@molecules/Modal'
import CloseIcon from '@icons/Close'
import { Video } from '@src/models/Video'

import * as style from './style.module.sass'

type VideoModalProps = {
  video: Video | undefined
  onClose: () => void
}
const VideoModal = ({ video, onClose }: VideoModalProps) => {
  return (
    <Modal
      show={video !== undefined}
      type="overlay-empty"
      outsideClick={onClose}
    >
      {video !== undefined && (
        <div className={style.modal} data-category={video.category}>
          <iframe src={`https://www.youtube.com/embed/${video.videoId}`} />
          <button onClick={onClose} className={style.close}>
            <CloseIcon />
          </button>
        </div>
      )}
    </Modal>
  )
}

export default VideoModal
